import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormSelect from "../../components/general/FormSelect";
import FormTextField from "../../components/general/FormTextField";
import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm,
} from "../../redux/actions/basicFormAction";
import { UPDATE_FORM_FIELD } from "../../redux/reduxConstants";
import FormMultiSelect from "../../components/general/FormMultiSelect";
import FormCheckbox from "../../components/general/FormCheckbox";
import { Col, Row } from "antd";
const style = { padding: '3px 0' };

const initialFormValues = {
  TerminalId: null,
  TerminalName: "",
  Prefix: "",
  BranchId: null,
  categoryIds: [],
  orderModeIds: [],
  tableIds: [],
  waiterIds: [],
  riderIds: [],
  EnableCheckout: true,
  DisplayAllCounterOrders: true,
  userIds: [],
};

const initialSearchValues = {
  TerminalId: null,
  TerminalName: "",
  Prefix: "",
  BranchId: null,
};

const columns = [
  {
    title: "Terminal",
    dataIndex: "TerminalName",
    key: "TerminalName",
  },
  {
    title: "Branch",
    dataIndex: "BranchName",
    key: "BranchName",
  },
];

const Counter = () => {
  // let defa = [2589,2590];
  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const [updateId, setUpdateId] = useState(null);
  const {
    formFields,
    searchFields,
    itemList,
    formLoading,
    tableLoading,
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);
  const [categoryIds, setCategoryIds] = useState([]);
  const [orderModeIds, setOrderModeIds] = useState([]);
  const [tableIds, setTableIds] = useState([]);
  const [waiterIds, setWaiterIds] = useState([]);
  const [riderIds, setRiderIds] = useState([]);
  const [userIds, setUserIds] = useState([]);

  useEffect(() => {
    dispatch(
      setInitialState(
        "/CrudTerminal",
        initialSearchValues,
        initialFormValues,
        initialSearchValues,
        controller,
        userData
      )
    );
    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  useEffect(() => {
    if (updateId !== null) {

      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: itemList.filter((item) => item.TerminalId === updateId)[0],
      });

      setCategoryIds(
        supportingTable?.Table8
          .filter(item => item.TerminalId === updateId)
          .map(a => a.CategoryId) || []);

      setOrderModeIds(
        supportingTable?.Table9
          .filter(item => item.TerminalId === updateId)
          .map(a => a.OrderModeId) || []);

      setTableIds(
        supportingTable?.Table10
          .filter(item => item.TerminalId === updateId)
          .map(a => a.TableId) || []);

      setWaiterIds(
        supportingTable?.Table11
          .filter(item => item.TerminalId === updateId)
          .map(a => a.WaiterId) || []);

      setRiderIds(
        supportingTable?.Table12
          .filter(item => item.TerminalId === updateId)
          .map(a => a.RiderId) || []);

      setUserIds(
        supportingTable?.Table13
          .filter(item => item.TerminalId === updateId)
          .map(a => a.UserId) || []);

    }
    setUpdateId(null);
  }, [updateId]);

  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    dispatch(setFormFieldValue(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchFields.TerminalName = searchFields.TerminalName.trim();
    dispatch(
      setInitialState(
        "/CrudTerminal",
        searchFields,
        initialFormValues,
        searchFields,
        controller,
        userData
      )
    );
  };

  const handleDeleteRow = (id) => {
    dispatch(
      deleteRow("/CrudTerminal", { TerminalId: id }, controller, userData)
    );
  };

  const handleFormSubmit = (e, id, _, closeForm) => {
    const updatedFormFields = {
      ...formFields,
      CategoryId: categoryIds,
      OrderModeId: orderModeIds,
      TableId: tableIds,
      WaiterId: waiterIds,
      RiderId: riderIds,
      UserIds: userIds,
    };

    e.preventDefault();
    dispatch(
      submitForm(
        "/CrudTerminal",
        updatedFormFields,
        initialFormValues,
        controller,
        userData,
        id
      )
    );
    setCategoryIds([]);
    setOrderModeIds([]);
    setTableIds([]);
    setWaiterIds([]);
    setRiderIds([]);
    setUserIds([]);
    closeForm();
  };

  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={4}
        label="Counter"
        name="TerminalName"
        size={INPUT_SIZE}
        value={searchFields.TerminalName}
        onChange={handleSearchChange}
      />

      <FormSelect
        colSpan={4}
        listItem={supportingTable.Table1 || []}
        idName="BranchId"
        valueName="BranchName"
        size={INPUT_SIZE}
        name="BranchId"
        label="Branch Name"
        value={searchFields.BranchId}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  const formPanel = (
    <Fragment>

      <FormTextField
        colSpan={6}
        label="Counter"
        name="TerminalName"
        size={INPUT_SIZE}
        value={formFields.TerminalName}
        onChange={handleFormChange}
        required
      />

      <FormSelect
        colSpan={6}
        listItem={supportingTable.Table1 || []}
        idName="BranchId"
        valueName="BranchName"
        size={INPUT_SIZE}
        name="BranchId"
        label="Branch Name"
        value={formFields.BranchId}
        onChange={handleFormChange}
        required
      />

      <FormCheckbox
        colSpan={6}
        idName="EnableCheckout"
        valueName="EnableCheckout"
        name="EnableCheckout"
        label="Checkout"
        checked={formFields.EnableCheckout}
        onChange={handleFormChange}
      />

      <FormCheckbox
        colSpan={6}
        idName="DisplayAllCounterOrders"
        valueName="DisplayAllCounterOrders"
        name="DisplayAllCounterOrders"
        label="Display All Orders"
        checked={formFields.DisplayAllCounterOrders}
        onChange={handleFormChange}
      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable.Table2 || []}
        idName="CategoryId"
        valueName="CategoryName"
        size={INPUT_SIZE}
        name="CategoryId"
        label="Category"
        value={categoryIds}
        onChange={setCategoryIds}
      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable.Table3 || []}
        idName="OrderModeId"
        valueName="OrderModeName"
        size={INPUT_SIZE}
        name="OrderModeId"
        label="Order Mode"
        value={orderModeIds}
        onChange={setOrderModeIds}
      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable?.Table4?.filter(a => a.BranchId === formFields.BranchId) || []}
        idName="TableId"
        valueName="TableName"
        size={INPUT_SIZE}
        name="TableId"
        label="Table"
        value={tableIds}
        onChange={setTableIds}

      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable?.Table5?.filter(a => a.BranchId === formFields.BranchId) || []}
        idName="WaiterId"
        valueName="WaiterName"
        size={INPUT_SIZE}
        name="WaiterId"
        label="Waiter"
        value={waiterIds}
        onChange={setWaiterIds}

      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable?.Table6?.filter(a => a.BranchId === formFields?.BranchId) || []}
        idName="RiderId"
        valueName="RiderName"
        size={INPUT_SIZE}
        name="RiderId"
        label="Rider"
        value={riderIds}
        onChange={setRiderIds}

      />

      <FormMultiSelect
        colSpan={12}
        listItem={supportingTable?.Table7?.filter(a => a.BranchId === formFields?.BranchId) || []}
        idName="UserId"
        valueName="FullName"
        size={INPUT_SIZE}
        name="UserId"
        label="User"
        value={userIds}
        onChange={setUserIds}

      />
    </Fragment>
  );

  return (
    <BasicFormComponent
      formWidth="75vw"
      formTitle="Counter"
      searchPanel={searchPanel}
      formPanel={formPanel}
      searchSubmit={handleSearchSubmit}
      onFormSave={handleFormSubmit}
      tableRows={itemList}
      tableLoading={tableLoading}
      formLoading={formLoading}
      tableColumn={columns}
      deleteRow={handleDeleteRow}
      actionID="TerminalId"
      editRow={setUpdateId}
      fields={initialFormValues}
    />
  );
};

export default Counter;
